import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import AddClinicComment from "./add-clinic-comment";
import { clinicService } from "../../../../services/clinicService";
import { NotificationManager } from "src/util/notify";

function ClinicComment() {
  const { state } = useLocation();
  const regionId = state?.field?.regionId;
  const clinicId = state?.field?.masterClinicId;
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const canAddComment = true;

  const handleEdit = () => {
    setIsEditing(true);
  };

  useEffect(() => {
    getClinicInfo();
  }, []);

  const getClinicInfo = async () => {
    setLoading(true);
    await clinicService
      .getClinicInfo(state)
      .then((result) => {
        setLoading(false);
        const data = result.resultData;
        setComment(data.comment);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleCloseComment = () => {
    setIsEditing(false);
    getClinicInfo();
  };

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h4 className="address-title text-grey">
          <span className="f-24">Clinic Comment</span>
        </h4>
        {canAddComment && (
          <button className="green-btn btn-primary" onClick={handleEdit}>
          <span
            className={`k-icon k-font-icon ${comment ? "k-i-edit" : "k-i-plus"}`}
            style={{ color: "#fff" }}
          ></span>{" "}
          {comment ? "Edit Comment" : "Add Comment"}
        </button>
        
        )}
      </div>
      <div className="mt-3">
        {comment ? (
          <textarea
            value={comment}
            readOnly
            disabled
            className="form-control"
            style={{height:'auto'}}
            rows="7"
          />
        ) : (
          <p className="text-muted">No comment available</p>
        )}
      </div>

      {isEditing && (
        <AddClinicComment
          onClose={handleCloseComment}
          clinicComment={comment}
          clinicId={clinicId}
          regionId={regionId}
        />
      )}
    </>
  );
}

export default ClinicComment;